<template>
  <div
    v-if="!isLoading"
    class="tw-px-[5px] tw-py-[3px] cell-status tw-flex tw-items-center tw-text-[11px] tw-font-[500] tw-rounded"
    :class="`${setColor} ${className}`"
  >
    <span data-cy="assessment-checklist-status-tag" class="class">{{
      checklistStatusId !== CHECKLISTSTATUS.DEFUNCT
        ? checklistStatus
        : getComponentUiText(
            "app-component-assessments-checklists-assessment-details-card-dfct-status-1",
          )
    }}</span>
  </div>
  <div v-else class="custom-global-skeleton tw-w-[36px] tw-h-[22.5px]"></div>
</template>

<script lang="ts" setup>
import { assessmentStatus } from "@/utils/constants";
import { getComponentUiText } from "@/utils/utilities";
import { PropType, computed } from "vue";
import { CHECKLISTSTATUS } from "@/utils/constants";

const props = defineProps({
  checklistStatus: {
    type: String as PropType<string>,
    default: "",
  },
  checklistStatusId: {
    type: String as PropType<string>,
    default: "",
  },
  isLoading: {
    type: Boolean,
    default: true,
  },
  className: {
    type: String as PropType<string>,
    default: "",
  },
});
const setColor = computed(() => {
  return getColor(props.checklistStatusId);
});

const getColor = (checklistStatusId: string) => {
  switch (checklistStatusId) {
    case CHECKLISTSTATUS.NEW:
      return CHECKLISTSTATUS.NOT_STARTED;
    case CHECKLISTSTATUS.INPROG:
      return CHECKLISTSTATUS.IN_PROGRESS;
    case CHECKLISTSTATUS.DONE:
      return CHECKLISTSTATUS.COMPLETED;
    case CHECKLISTSTATUS.WAIT:
    case CHECKLISTSTATUS.PAUS:
    case CHECKLISTSTATUS.OTH:
      return CHECKLISTSTATUS.ONHOLD;
    case CHECKLISTSTATUS.DEFUNCT:
      return assessmentStatus.defunct;
    case CHECKLISTSTATUS.CREATED:
      return assessmentStatus.created;
    case CHECKLISTSTATUS.SUBMITTED:
      return assessmentStatus.submitted;
    default:
      return "";
  }
};

const statusAssessment = {};

statusAssessment[assessmentStatus.inProgress] = {
  label: getComponentUiText(
    "app-component-assessments-checklists-assessment-details-card-status-1",
  ),
  className: "inProgress",
};
statusAssessment[assessmentStatus.notStarted] = {
  label: getComponentUiText(
    "app-component-assessments-checklists-assessment-details-card-status-5",
  ),
  className: "notStarted",
};
statusAssessment[assessmentStatus.complete] = {
  label: getComponentUiText(
    "app-component-assessments-checklists-assessment-details-card-status-3",
  ),
  className: "complete",
};
statusAssessment[assessmentStatus.created] = {
  label: getComponentUiText(
    "app-component-assessments-checklists-assessment-details-card-status-2",
  ),
  className: "notStarted",
};
statusAssessment[assessmentStatus.completed] = {
  label: getComponentUiText(
    "app-component-assessments-checklists-assessment-details-card-status-3",
  ),
  className: "completed",
};
statusAssessment[assessmentStatus.waitingOnUs] = {
  label: getComponentUiText(
    "app-component-assessments-checklists-assessment-details-card-status-5",
  ),
  className: "onHold",
};
statusAssessment[assessmentStatus.waiting] = {
  label: getComponentUiText(
    "app-component-assessments-checklists-assessment-details-card-status-5",
  ),
  className: "onHold",
};
statusAssessment[assessmentStatus.paused] = {
  label: getComponentUiText(
    "app-component-assessments-checklists-assessment-details-card-status-5",
  ),
  className: "onHold",
};
statusAssessment[assessmentStatus.other] = {
  label: getComponentUiText(
    "app-component-assessments-checklists-assessment-details-card-status-5",
  ),
  className: "onHold",
};
statusAssessment[assessmentStatus.audited] = {
  label: getComponentUiText(
    "app-component-assessments-checklists-assessment-details-card-status-4",
  ),
  className: "audited",
};
statusAssessment[assessmentStatus.defunct] = {
  label: "DEFUNCT",
  className: "defunct",
};
statusAssessment[assessmentStatus.submitted] = {
  label: getComponentUiText(
    "app-component-assessments-checklists-assessment-details-card-status-submitted",
  ),
  className: "Submitted",
};
</script>

<style>
.inProgress {
  background: linear-gradient(
      0deg,
      rgba(72, 160, 255, 0.15) 0%,
      rgba(72, 160, 255, 0.15) 100%
    ),
    #fff;
  color: #387dff;
}

.notStarted {
  background: var(--ui-orange-soft, #fee5e2);
  color: #f7553c;
}

.completed {
  background: var(--ui-green-soft, #d9ede2);
  color: #01893d;
}

.audited {
  background: linear-gradient(
      0deg,
      rgba(144, 75, 214, 0.15) 0%,
      rgba(144, 75, 214, 0.15) 100%
    ),
    #fff;
  color: #904bd6;
}

.onHold {
  background: #fff0da;
  color: #fe9a05;
}

.Defunct {
  background: var(--ui-orange-soft, #fee5e2);
  color: #f7553c;
}

.Created {
  background: var(--ui-orange-soft, #fee5e2);
  color: #f7553c;
}
.Submitted {
  background-color: var(--UI-light-sky-soft, #e4f1ff);
  color: var(--Brand-Dark-Sky, #387dff);
}
</style>
